.ol {
    composes: listReset from "../../styles/composable/utility.module.css";
}
